
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Action, Getter } from 's-vuex-class'
import { CardIndex } from '../../../entities/conversation'
import DropMenu from './DropMenu.vue'
import JumpArrow from './JumpArrow.vue'

/**
 * @todo break this component into inline and popout variants
 * or otherwise re-use code better
 */

@Component<FlowJumpEditor>({
    components: {
        DropMenu,
        JumpArrow,
    },
})
export default class FlowJumpEditor extends Vue {
    @Prop(String) public value?: string
    @Prop(Boolean) public inline?: boolean
    @Prop(Object) public cardIndex!: CardIndex

    @Action public createFlow!: (name: string) => void
    @Action public activateTab!: (tabName: string) => void

    @Getter public getFlowNames!: string[]
    @Getter public getMasterNames!: string[]

    public newFlowName = ''
    public flowNameError = ''

    public get getOptions() {
        // You can jump to any master section after the current one, or any flow
        return this.getMasterNames
            .slice(this.cardIndex.sectionIndex + 1)
            .concat(this.getFlowNames)
    }

    public reset() {
        this.newFlowName = ''
        this.flowNameError = ''
    }

    public updateJump(jump: string) {
        this.$emit('change', jump)
    }

    public removeJump() {
        this.$emit('remove')
    }

    public createFlowAndJump(event: Event) {
        event.preventDefault()

        const name = this.newFlowName.trim()
        this.validateFlowName()

        if (!this.flowNameError && name !== '') {
            this.createFlow(name)
            this.updateJump(name)
            this.navigateToNewFlow(name)
        }
    }

    public validateFlowName() {
        const name = this.newFlowName.trim()
        if (name === 'none') {
            this.flowNameError = 'Invalid name'
        } else if (
            this.getFlowNames.concat(this.getMasterNames).indexOf(name) > -1
        ) {
            this.flowNameError = 'New flow must have a unique name'
        } else {
            this.flowNameError = ''
        }
    }

    public navigateToNewFlow(name: string) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        setTimeout(() => this.activateTab(name), 500) // delay gives vuex time to update
    }
}
